import React from 'react';
import ReactCountryFlag from 'react-country-flag';
import { proxyImage } from '@rsmaids/shared/utils/avatarUtils';

// react-country-flag loads each flag straight from cdn.jsdelivr.net, which
// browsers' Tracking Prevention blocks. Route it through the same imageProxy
// used for avatars: the proxied prefix is URL-encoded, so the "us.svg" the
// library appends decodes back into the full flag URL on the server.
// i18n-ignore: asset URL, not user-visible text
const FLAG_BASE_URL = proxyImage('https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/') ?? undefined;

type Props = Omit<React.ComponentProps<typeof ReactCountryFlag>, 'svg' | 'cdnUrl'>;

const CountryFlag: React.FC<Props> = (props) => (
  <ReactCountryFlag {...props} svg cdnUrl={FLAG_BASE_URL} />
);

export default CountryFlag;
